import React from 'react';

import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import { LinearProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import { AccountBox, CloudUpload } from 'material-ui-icons';
import { TextField } from 'material-ui';

import OLYWebPageComponent from '../OLYWebPageComponent';
import isEmail from 'validator/lib/isEmail';
import { getAgency, saveAgency } from './agencyServices';
import { reconnect } from '../Login/loginService';

import { translate } from 'react-i18next';
import { Typography, withStyles, Grid, InputLabel } from '../../../node_modules/material-ui';
import Dropzone from 'react-dropzone';

import { getUserInformation } from './../Login/loginService';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)',
    },
    myDropZone: {
        position: 'relative',
        height: '80px',
        borderStyle: 'dashed',
        borderWidth: '2px',
        borderRadius: '5px',
        textAlign: 'center'
    },
    activeDropZone: {
        borderStyle: 'solid',
        borderColor: '#6c6',
        backgroundColor: '#eee'
    },
    rejectedDropZone: {
        borderStyle: 'solid',
        borderColor: '#c66',
        backgroundColor: '#eee'
    }
});
class AgencyView extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            agency: {},
            failedName: true,
            failedEmail: true,
            failedAddress: true,
            failedPhone: true,
            agencyImage: {},
            voucherImage: {},
            dirtyData: false
        };
        this.pageName = 'AgencyView';
        this.getAgency();
    }

    getAgency = () => {
        this.setState({ loading: true });
        getAgency().then(result => {
            this.setState({
                agency: result,
                failedName: (result.name.trim() === ''),
                failedEmail: !this.validateEmail(result.email),
                failedAddress: (result.address ? result.address.trim() === '' : true),
                failedPhone: (result.telephone ? result.telephone.trim() === '' : true)
            });
        }).catch(error => {
            alert(error.message);
        }).finally(data => {
            this.setState({ loading: false });
        });
    };

    validateEmail = (email) => {
        if (email) {
            return email.trim() !== '' && isEmail(email);
        }
        else {
            return false;
        }
    };

    saveAgency = () => {
        this.setState({ loading: true });
        const cu = getUserInformation();
        let imageChanged = false;
        saveAgency(this.state.agency)
            .then(result => {
                imageChanged = (this.state.imageDeleted || result.LogoImage !== '') && (result.LogoImage !== cu.user_detail.photo);
                this.setState({ loading: false, dirtyData: false, imageDeleted: false });
                alert(this.props.t('AGENCY.UPDATED_SUCESS'));
            })
            .then(result => {
                if (imageChanged) {
                    return reconnect();
                }
            })
            .then(r2 => {
                if (imageChanged) {
                    window.location.reload();
                }
            })
            .catch(error => {
                if (error.type === 'AGENCY_DUPLICATED_ERROR') {
                    this.setState({ failedName: true });
                }
                alert(error.message + '\n' + (error.detailedMessage ? error.detailedMessage : ''));
            })
            .finally(data => {
                this.setState({ loading: false });
            });
    };

    disableSaveButton = () => {
        return this.state.loading || this.state.failedName ||
            this.state.failedEmail || this.state.failedSendEmail ||
            this.state.failedAddress || this.failedPhone ||
            !this.state.dirtyData;
    };

    setImage = (acceptedFiles, rejectedFiles, agencyPropImage) => {
        if (rejectedFiles[0]) {
            alert(this.props.t('AGENCY.IMAGE_LOAD_ERROR'));
            return false;
        }

        let agency = this.state.agency;
        const file = acceptedFiles[0];
        if (file.name) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                agency[agencyPropImage] = reader.result;
            };
            reader.onerror = error => {
                agency[agencyPropImage] = '';
            };
        }
        else {
            agency[agencyPropImage] = '';
        }

        this.setState({
            agency: agency,
            dirtyData: true
        });
        return true;
    }

    onAgencyImageDrop = (acceptedFiles, rejectedFiles) => {
        if (this.setImage(acceptedFiles, rejectedFiles, 'logoImage')) {
            this.setState({
                agencyImage: acceptedFiles[0]
            });
        }
    };

    onVoucherImageDrop = (acceptedFiles, rejectedFiles) => {

        if (this.setImage(acceptedFiles, rejectedFiles, 'voucherImage')) {
            this.setState({
                voucherImage: acceptedFiles[0]
            });
        }
    };

    renderAgencyImagePreview = () => {
        const { t } = this.props;

        if (!this.hasAgencyImage()) {
            return (
                <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                    <CloudUpload style={{ width: 64, height: 64 }} />
                </div>
            );
        }
        else {
            if (this.state.agencyImage && this.state.agencyImage.preview) {
                return (
                    <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                        <img
                            src={this.state.agencyImage.preview}
                            alt={this.state.agencyImage.name}
                            style={{ height: '80px' }}
                        />
                    </div>
                );
            }
            else {
                return (
                    <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                        <img
                            src={this.state.agency.logoImage}
                            alt={t('AGENCY.LOGO_AGENCY')}
                            style={{ height: '80px' }}
                        />
                    </div>
                );
            }
        }
    };

    renderVoucherImagePreview = () => {
        const { t } = this.props;

        if (!this.hasVoucherImage()) {
            return (
                <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                    <CloudUpload style={{ width: 64, height: 64 }} />
                </div>
            );
        }
        else {
            if (this.state.voucherImage && this.state.voucherImage.preview) {
                return (
                    <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                        <img
                            src={this.state.voucherImage.preview}
                            alt={this.state.voucherImage.name}
                            style={{ height: '80px' }}
                        />
                    </div>
                );
            }
            else {
                return (
                    <div title={t('AGENCY.IMAGE_LOAD_MESSAGE')}>
                        <img
                            src={this.state.agency.voucherImage}
                            alt={t('AGENCY.LOGO_VOUCHER')}
                            style={{ height: '80px' }}
                        />
                    </div>
                );
            }
        }
    };

    removeAgencyImage = () => {
        let agency = this.state.agency;
        agency.logoImage = '';
        this.setState({
            agency: agency,
            imageDeleted: true,
            agencyImage: null,
            dirtyData: true
        });
    }

    removeVoucherImage = () => {
        let agency = this.state.agency;
        agency.voucherImage = '';
        this.setState({
            agency: agency,
            voucherImage: null,
            dirtyData: true
        });
    }

    hasAgencyImage() {
        return (this.state.agencyImage && this.state.agencyImage.preview) ||
            this.state.agency.logoImage;
    }

    hasVoucherImage() {
        return (this.state.voucherImage && this.state.voucherImage.preview) ||
            this.state.agency.voucherImage;
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className="cmsAgency">
                <div style={{ margin: '5px' }}>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <Paper style={{ margin: 15, padding: 20 }}>
                    <Typography className={classes.tableTitle}>
                        <AccountBox style={{ width: 32, height: 32, float: 'left' }} />
                        <strong style={{ paddingLeft: 8 }}>{t('PAGE_TITLES.AgencyView')}</strong>
                    </Typography>
                    <div style={{ paddingLeft: 38 }}>
                        <Grid
                            container
                            direction={'row'}
                            alignItems={'baseline'}
                            style={{ marginTop: '10px' }}
                        >
                            <Grid item xs={6} >
                                <Grid
                                    container
                                    direction={'row'}
                                    alignItems={'baseline'}
                                    style={{ marginTop: '10px' }}
                                >
                                    <Grid item xs={4}>
                                        <InputLabel
                                            htmlFor="logoAgency"
                                            className={classes.inputLabel}
                                            shrink={true} >
                                            {t('AGENCY.LOGO_AGENCY')}
                                        </InputLabel>
                                        < br />< br />
                                        <Dropzone
                                            multiple={false}
                                            accept="image/png"
                                            maxSize={200000}
                                            onDrop={this.onAgencyImageDrop.bind(this)}
                                            className={classes.myDropZone}
                                            activeClassName={classes.activeDropZone}
                                            rejectClassName={classes.rejectedDropZone}
                                            style=
                                                {
                                                    this.hasAgencyImage() ?
                                                        { borderStyle: 'none' }
                                                        :
                                                        ''
                                                }
                                        >
                                            {
                                                this.renderAgencyImagePreview()
                                            }
                                        </Dropzone>
                                        <Typography variant='caption' style={{ marginTop: '10px' }}>
                                            {t('AGENCY.AGENCY_IMAGE_SPECS')}
                                        </Typography>
                                        {
                                            this.hasAgencyImage() ?
                                                <Button 
                                                    style={{
                                                        margin: 'auto',
                                                        display: 'inherit'
                                                    }}
                                                    onClick={() => this.removeAgencyImage()}
                                                    color="secondary"
                                                >
                                                    {t('AGENCY.REMOVE_IMAGE')}
                                                </Button>
                                                : ''
                                        }
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction={'row'}
                                    alignItems={'baseline'}
                                    style={{ marginTop: '10px' }}
                                >
                                    <Grid item xs={4} >
                                        <InputLabel
                                            htmlFor="voucherImage"
                                            className={classes.inputLabel}
                                            shrink={true} >
                                            {t('AGENCY.LOGO_VOUCHER')}
                                        </InputLabel>
                                        < br />< br />
                                        <Dropzone
                                            multiple={false}
                                            accept="image/png"
                                            maxSize={200000}
                                            onDrop={this.onVoucherImageDrop.bind(this)}
                                            className={classes.myDropZone}
                                            activeClassName={classes.activeDropZone}
                                            rejectClassName={classes.rejectedDropZone}
                                            style=
                                                {
                                                    this.hasVoucherImage() ?
                                                        { borderStyle: 'none' }
                                                        :
                                                        ''
                                                }
                                        >
                                            {
                                                this.renderVoucherImagePreview()
                                            }
                                        </Dropzone>
                                        <Typography variant='caption' style={{ marginTop: '10px' }}>
                                            {t('AGENCY.VOUCHER_IMAGE_SPECS')}
                                        </Typography>
                                        {
                                            this.hasVoucherImage() ?
                                                <Button
                                                    style={{
                                                        margin: 'auto',
                                                        display: 'inherit'
                                                    }}
                                                    onClick={() => this.removeVoucherImage()}
                                                    color="secondary"
                                                >
                                                    {t('AGENCY.REMOVE_IMAGE')}
                                                </Button>
                                                : ''
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>

                            <br /><br />

                            <Grid item xs={6}>

                                <FormControl component="fieldset" style={{ width: '300px' }}>
                                    <TextField
                                        fullWidth
                                        label={t('AGENCY.NAME')}
                                        required={true}
                                        value={this.state.agency.name}
                                        placeholder={t('AGENCY.NAME')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel
                                        }}
                                        onChange={event => {
                                            let agency = this.state.agency;
                                            agency.name = String(event.target.value);
                                            this.setState({
                                                agency: agency,
                                                dirtyData: true,
                                                failedName: (agency.name.trim() === '')
                                            });
                                        }}
                                        error={this.state.failedName}
                                    />
                                </FormControl>
                                <br /><br />
                                <FormControl component="fieldset" style={{ width: '300px' }}>
                                    <TextField
                                        fullWidth
                                        label={t('AGENCY.ADDRESS')}
                                        required={true}
                                        value={this.state.agency.address || ''}
                                        placeholder={t('AGENCY.ADDRESS')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel
                                        }}
                                        onChange={event => {
                                            let agency = this.state.agency;
                                            agency.address = String(event.target.value);
                                            this.setState({
                                                agency: agency,
                                                dirtyData: true,
                                                failedAddress: (agency.address.trim() === '')
                                            });
                                        }}
                                        error={this.state.failedAddress}
                                    />
                                </FormControl>
                                <br /><br />
                                <FormControl style={{ width: '300px', paddingRight: '20px' }} component="fieldset">
                                    <TextField
                                        fullWidth
                                        label={t('AGENCY.EMAIL')}
                                        value={this.state.agency.email}
                                        required={true}
                                        placeholder={t('AGENCY.EMAIL')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel
                                        }}
                                        onChange={event => {
                                            let agency = this.state.agency;
                                            agency.email = String(event.target.value);
                                            this.setState({
                                                agency: agency,
                                                dirtyData: true,
                                                failedEmail: !this.validateEmail(agency.email)
                                            });
                                        }}
                                        error={this.state.failedEmail}
                                    />
                                </FormControl>
                                <br /><br />
                                <FormControl style={{ width: '300px', paddingRight: '20px' }} component="fieldset">
                                    <TextField
                                        fullWidth
                                        label={t('AGENCY.REPLY_TO')}
                                        value={this.state.agency.sendEmail}
                                        placeholder={t('AGENCY.REPLY_TO')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel
                                        }}
                                        onChange={event => {
                                            let agency = this.state.agency;
                                            agency.sendEmail = String(event.target.value).trim();
                                            let failed = agency.sendEmail !== '' ? !isEmail(agency.sendEmail) : false;
                                            this.setState({
                                                agency: agency,
                                                dirtyData: true,
                                                failedSendEmail: failed
                                            });
                                        }}
                                        error={this.state.failedSendEmail}
                                    />
                                </FormControl>
                                <br /><br />
                                <FormControl style={{ width: '300px', paddingRight: '20px' }} component="fieldset">
                                    <TextField
                                        fullWidth
                                        label={t('AGENCY.PHONE')}
                                        value={this.state.agency.telephone || ''}
                                        placeholder={t('AGENCY.PHONE')}
                                        required={true}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel
                                        }}
                                        onChange={event => {
                                            let agency = this.state.agency;
                                            agency.telephone = String(event.target.value);
                                            this.setState({
                                                agency: agency,
                                                dirtyData: true,
                                                failedPhone: (agency.telephone.trim() === '')
                                            });
                                        }}
                                        error={this.state.failedPhone}
                                    />
                                </FormControl>
                                <br /><br />
                                <Typography variant='caption'>{t('CONFIRM_BOOKING.REQUIRED_FIELDS')}</Typography>
                            </Grid>

                        </Grid>
                        <Grid
                            container
                            direction={'row'}
                            alignItems={'baseline'}
                        >
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    variant="raised"
                                    style={{ marginLeft: 210, display: 'inline-block' }}
                                    onClick={() => this.saveAgency()}
                                    disabled={this.disableSaveButton()}
                                    color="secondary">{t('COMMON.SAVE')}
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>

            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(AgencyView));


// WEBPACK FOOTER //
// ./src/components/Agency/AgencyView.js